import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { AsmComponentService } from '@asm/feature';
import { User } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user';
import { Observable, Subscription } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cx-customer-emulation',
  templateUrl: './customer-emulation.component.html',
  imports: [AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerEmulationComponent implements OnInit, OnDestroy {
  customer: User;
  isCustomerEmulationSessionInProgress$: Observable<boolean>;
  protected subscription = new Subscription();

  constructor(
    protected asmComponentService: AsmComponentService,
    protected userAccountFacade: UserAccountFacade,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      // eslint-disable-next-line deprecation/deprecation
      this.userAccountFacade.get().subscribe((user) => {
        if (user) this.customer = user;
      }),
    );
    this.isCustomerEmulationSessionInProgress$ = this.asmComponentService.isCustomerEmulationSessionInProgress();
  }

  logoutCustomer(): void {
    this.asmComponentService.logoutCustomer();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
